import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import SMSTierDialogV2 from './SMSTierDialog';
import SMSTierDialogV1 from './SMSTierDialogV1';
import MyAccountApiLite from '../../api/MyAccountApiLite';

const { getRMCValue } = MyAccountApiLite;

const SMSTierDialog = (props) => {
  const [useSMSV2, setUseSMSV2] = useState(null);

  useEffect(() => {
    (async () => {
      const useSMSV2Local = await getRMCValue('USE_SMS_V2');

      setUseSMSV2(useSMSV2Local);
    })();
  }, []);

  if (useSMSV2 != null) {
    const SMSComponent = useSMSV2 ? SMSTierDialogV2 : SMSTierDialogV1;

    return <SMSComponent {...props} />;
  }

  return null;
};

SMSTierDialog.defaultProps = {
  smsPurchasedCallback: null,
  closeOnSuccess: false,
};

SMSTierDialog.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  closeOnSuccess: PropTypes.bool,
  smsPurchasedCallback: PropTypes.func,
};

export default SMSTierDialog;
